"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHILD_AGE_GENDER = void 0;
exports.CHILD_AGE_GENDER = Object.freeze({
    NO_CHILDREN_CHILD_AGE_QUOTA: 167,
    GIRLS_MONTHS: [112, 114, 116, 118, 120, 122, 124, 126, 128, 130, 132],
    BOYS_MONTHS: [111, 113, 115, 117, 119, 121, 123, 125, 127, 129, 131],
    GIRLS_YEARS: [
        134, 136, 138, 140, 142, 144, 146, 148, 150, 152, 154, 156, 158, 160, 162,
        164, 166,
    ],
    BOYS_YEARS: [
        133, 135, 137, 139, 141, 143, 145, 147, 149, 151, 153, 155, 157, 159, 161,
        163, 165,
    ],
    GIRLS_CONDITIONS_CODES: [
        112, 114, 116, 118, 120, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140,
        142, 144, 146, 148, 150, 152, 154, 156, 158, 160, 162, 164, 166,
    ],
    BOYS_CONDITIONS_CODES: [
        111, 113, 115, 117, 119, 121, 123, 125, 127, 129, 131, 133, 135, 137, 139,
        141, 143, 145, 147, 149, 151, 153, 155, 157, 159, 161, 163, 165,
    ],
});
